import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'student',
  initialState: {
    studentData: [],
  },
  reducers: {
    setStudentData: (state, action) => {
      state.studentData = action.payload;
    },
  },
});

export const { setStudentData } = userSlice.actions;
export default userSlice.reducer;
